import React from "react"
import Layout from "../../components/layout"
import { Helmet } from "react-helmet"

import SEO from "../../components/seo"
import { useStaticQuery, graphql } from "gatsby"

import BackgroundSlider from "gatsby-image-background-slider"

const TrinchePage = () => {
  return (
    <Layout>
      <SEO title="Carlovich. No te voy a mentir " />
      <Helmet>
        <body className="domFiber" />
      </Helmet>
      <div className="flex items-center justify-center pt-32 carlovich">
        <div className="w-full max-w-xl m-auto my-0 ">
          <h1 className="inline-block max-w-4xl px-6 py-2 font-mono text-3xl font-bold text-center text-gray-400 uppercase bg-gray-800 shadow-2xl tarantos-title">
            Carlovich. No te voy a mentir
          </h1>
          <iframe
            width="100%"
            height="300"
            title="Carlovich. No te voy a mentir"
            scrolling="no"
            frameBorder="no"
            allow="autoplay"
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/788682118&color=%23281136&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true"
          ></iframe>
          <p
            className="px-8 py-12 mb-6 font-serif text-base"
            style={{
              background: "rgba(40, 17, 54, 0.9)",
            }}
          >
            En La <b> Ciudad Ausente</b>, texto que publica Ricardo Piglia en el
            92, la máquina de Macedonio produce y engloba la totalidad de las
            historias habidas y posibles. Unos años antes Borges había tenido la
            misma idea, pero en vez de una máquina era el Aleph, y lo definía
            como ese punto del espacio que contiene todos los puntos. La de
            Tomás Felipe Carlovich es una historia, y por lo tanto, es una de
            las historias de la máquina de Macedonio (o uno de los puntos del
            Aleph). La historia de la máquina también es una de las historias de
            la máquina, y la historia del propio Macedonio, también lo es.
            <br />
            <br />
            Historias de la máquina son todas aquellas que constituyen el mito
            Carlovich, como la que cuenta que jugó todo un campeonato de
            suplente en honor a un surubí: en esa época la numeración de las
            camisetas iba del 1 al 11 para los titulares, y del 12 al 18 para
            los suplentes. Carlovich había decidido jugar con la 17, que era lo
            que pesaba el surubí que él había pescado.
            <br />
            <br />
            Quienes lo vieron en Central Córdoba afirman que una vez, en la
            temporada del ´82, jugó todo el partido de primera. Nunca necesitó
            dos tiempos para resolver.
            <br />
            <br />
            Ante la consulta de un periodista por su falta de cualidades para
            recuperar la pelota, Carlovich respondió que no se tiraba al piso
            porque era muy amigo del canchero y que se lo había prohibido.
            <cite
              className="block p-6 my-12 -mx-5 font-sans text-2xl text-center md:-mx-24"
              style={{
                background: "rgba(134, 17, 49, 0.8)",
              }}
            >
              Carlovich era un tipo solitario, y esto lo perjudicó en su carrera
              deportiva, muchas veces faltó a entrenar porque prefería quedarse
              sólo:{" "}
              <b>
                "sí, sí, a veces soy de juntarme con alguien, pero no mucho
                ¿viste? Me gusta más la tranquilidad. Para mí ir a entrenar es
                una reunión”.
              </b>
            </cite>
            Otra historia cuenta que Carlovich la pisaba con las dos piernas y
            que caminaba todo el partido. La constante es que siempre se puede
            contar una historia más. En este sentido el mito Carlovich plantea
            una ecuación de la falta, algo así como la totalidad menos 1; y se
            diferencia, por lo tanto, de la estructura de la máquina de
            Macedonio y del Aleph, que son completas porque contemplan las
            historias que todavía no se contaron.
            <br />
            <br />
            Son necesarios para el mito Carlovich tanto sus divulgadores, sobre
            todo la legitimidad de ellos (Maradona, Menotti, Bielsa, Pekerman, y
            los demás.), como también la falta de evidencias. Esta ausencia es
            fundamental para romper con la vieja medida de <i>Verdad-Mentira</i>
            .
            <br />
            <br />
            Lo que no creemos nos hace tanto como nuestras creencias. Creer en
            Carlovich es pertenecer al grupo íntimo de futbolerxs. Esa pasión
            intensa y compartida es paradojal porque “no se puede explicar con
            palabras” pero está íntegramente hecha con palabras. Es decir, las
            palabras crean cosas que no pueden explicar. Por estar hecho de
            palabras y por la ausencia de evidencias se puede decir que
            Carlovich es indiferente al avance tecnológico: no lo necesitó en su
            origen y no lo requiere para la supervivencia.
            <br />
            <br />
            El mito Carlovich tiene una configuración inversa a la del acertijo,
            porque se sabe cuál es el resultado pero se desconocen sus
            características, las cuales debe proveer la imaginación y el de
            Carlovich es un juego de la fantasía.
            <cite
              className="block p-6 my-12 -mx-5 font-sans text-2xl text-center md:-mx-24"
              style={{
                background: "rgba(134, 17, 49, 0.8)",
              }}
            >
              El día que Maradona llegó a Rosario para jugar en Newell´s le
              gritaron que era un orgullo tener al mejor del mundo en la ciudad,
              él contestó: “el mejor siempre estuvo acá, y es el Trinche
              Carlovich”.{" "}
            </cite>
            Claro que la respuesta no podría haber sido otra porque Maradona,
            que también es mito, tiene la obligación literaria de reproducir
            ampliamente la historia de Carlovich. <br />
            Cuando Maradona declara
            <b>“Carlovich era mejor que yo”</b>, se refiere a ellos como mitos y
            no como jugadores. Y tiene razón, porque Carlovich necesitó mostrar
            menos su fútbol que él para serlo. <br /> Sin embargo, Maradona tomó
            un camino inverso al de Carlovich: primero mostró todas sus
            habilidades que dejaron el terreno listo para albergar cualquier
            historia. Carlovich parte de historias diversas que traslucen sus
            destrezas.
            <br />
            <br />
            Puede ser discutible que Maradona sea el mejor jugador de todos los
            tiempos, pero es indiscutible que es el más comentado, el que más
            historias permitió. Fue él mismo quién prendió la máquina de
            Macedonio.
            <br />
            <br />
            Macedonio Fernández es el mito de la literatura porteña. En relación
            a la configuración mítica de Carlovich, se ve perjudicado porque de
            lo suyo hay registro. Su hijo, que editó{" "}
            <i>El museo de la novela de la eterna</i>, atentó contra la vocación
            mitológica de Macedonio, a quién se lo puede interpretar como un
            homicida imperfecto, alguien que se propone realizar el acto sin
            dejar huellas, pero que de todas formas descubren su autoría.
            <br />
            <br />
            Si su hijo funciona como el detective que descubre las pruebas y
            arma el caso en torno a ellas restándole capacidad mítica, las
            historias que de Macedonio cuentan Borges y Piglia son su
            contrapeso. Ellas otorgan la fantasía que la realidad de las
            demostraciones le quiere quitar.
            <br />
            <br />
            Cuando Maradona dijo que Carlovich era mejor que él, trasladó la
            discusión al plano de lo mitológico. Este plano queda vedado en una
            discusión sobre Macedonio y Borges, ya que al haber documentos de lo
            que hizo Macedonio la discusión queda en el ámbito del litigio
            positivo, negándole el ingreso a la zona de imágenes y creencias.
            <br />
            <br />
            Carlovich jugó en un tiempo donde no todo se registraba, Macedonio
            escribió en un tiempo donde las cosas se perdían, y su hijo Adolfo
            vivió en un tiempo donde las cosas no se pierden sino que se ocultan
            en la cantidad. De ahí su credulidad para encontrar y publicar lo
            que Macedonio había escrito.
            <br />
            <br />
            En Carlovich todo lo que tiene que ver con lo deportivo quedó opaco,
            eso nos pone de frente ante nuestra imaginación, y no hay nadie que
            haya estimulado más la imaginación en la ciudad que el propio
            Macedonio: él y Carlovich son el murmullo sobre el cual acontece la
            ciudad.
            <br /> Esto no es extraño pues se rumoreaba que físicamente eran muy
            parecidos, y si el cuerpo es el que delimita la percepción del
            mundo, Macedonio y Carlovich habitan mundos similares.
            <br />
            <cite
              className="block p-6 my-12 -mx-5 font-sans text-2xl text-center md:-mx-24"
              style={{
                background: "rgba(134, 17, 49, 0.8)",
              }}
            >
              Macedonio decía: <br /> “lo que se puede imaginar sucede <br /> y
              pasa a formar parte de lo que es”.
              <br />
              Lo decía por Carlovich, y por él.
              <br />
              Lo decía por Carlovich, y por él.
            </cite>
          </p>
          <BackgroundSlider
            className=" bgslider"
            initDelay={3}
            images={["img233.jpg", "4511.jpg"]}
            transition={2}
            duration={8}
            query={useStaticQuery(graphql`
              query {
                backgrounds: allFile(
                  filter: { sourceInstanceName: { eq: "backgrounds" } }
                ) {
                  nodes {
                    relativePath
                    childImageSharp {
                      fluid(
                        maxWidth: 2000
                        quality: 100
                        duotone: { highlight: "#f00e2e", shadow: "#281136" }
                        traceSVG: { color: "#281136" }
                      ) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                }
              }
            `)}
          />
        </div>
      </div>
    </Layout>
  )
}

export default TrinchePage
